import './index.css'
import { fmt } from '../../lib/format'
import type { SummaryCardsProps } from '../../types'

export default function SummaryCards({
  realizedIncome, projectedIncome,
  realizedExpense, projectedExpense,
  realizedBalance, projectedBalance,
  projectedPct,
}: SummaryCardsProps) {
  const negBal = realizedBalance < 0
  const negProj = projectedBalance < 0
  return (
    <div className="bc-summary" data-tour="summary-cards">
      <div className="bc-card bc-summary__cell">
        <div className="bc-card__lbl">Receitas do mês</div>
        <div className="bc-card__val bc-card__val--pos">R$ {fmt(realizedIncome)}</div>
        <div className="bc-card__sub">Previsto: R$ {fmt(projectedIncome)}</div>
      </div>

      <div className="bc-card bc-summary__cell">
        <div className="bc-card__lbl">Despesas do mês</div>
        <div className="bc-card__val bc-card__val--neg">R$ {fmt(realizedExpense)}</div>
        <div className="bc-card__sub">Previsto: R$ {fmt(projectedExpense)} · {projectedPct}% da renda</div>
      </div>

      <div className={'bc-card bc-summary__cell ' + (negBal ? 'is-neg' : 'is-pos')}>
        <div className="bc-card__lbl">Saldo</div>
        <div className={'bc-card__val ' + (negBal ? 'bc-card__val--neg' : 'bc-card__val--pos')}>
          {negBal ? '−' : '+'} R$ {fmt(Math.abs(realizedBalance))}
        </div>
        <div className="bc-card__sub">
          Projetado: {negProj ? '−' : '+'} R$ {fmt(Math.abs(projectedBalance))}
        </div>
      </div>
    </div>
  )
}
